import { getRadiusFromBounds } from '@sg/radar-fe';

import { LOCATION_SEARCH_MACHINE_MINIMUM_RADIUS_MILES } from '../LocationSearchMachine.constants';

// ─── Helpers ──────────────────────────────────────────────────────────────────

/**
 * Expands bounds to ensure a minimum radius.
 *
 * @returns Bounds that meet the minimum radius requirement
 */
export function expandBoundsToMinimumRadius(params: ExpandBoundsToMinimumRadiusParams): Bounds {
  const { bounds, centerLat, centerLng } = params;

  const currentRadius = getRadiusFromBounds(centerLat, centerLng, bounds);

  // If current radius meets or exceeds minimum, return original bounds
  if (currentRadius >= LOCATION_SEARCH_MACHINE_MINIMUM_RADIUS_MILES) {
    return bounds;
  }

  // Calculate the delta needed to expand to minimum radius
  const deltaRadius = LOCATION_SEARCH_MACHINE_MINIMUM_RADIUS_MILES * ONE_MILE_DELTA; // prettier-ignore

  // Expand bounds from center point
  return {
    southwest: { lat: centerLat - deltaRadius, lng: centerLng - deltaRadius },
    northeast: { lat: centerLat + deltaRadius, lng: centerLng + deltaRadius },
  };
}

// ─── Constants ───────────────────────────────────────────────────────────────

// eslint-disable-next-line unicorn/numeric-separators-style
const ONE_MILE_DELTA = 0.01153;

// ─── Types ───────────────────────────────────────────────────────────────────

type Bounds = {
  southwest: { lat: number; lng: number };
  northeast: { lat: number; lng: number };
};

type ExpandBoundsToMinimumRadiusParams = {
  bounds: Bounds;
  centerLat: number;
  centerLng: number;
};
